/**
 * What an organization unit owns, section by section.
 *
 * Mostly configuration — master data maintained on the root or a company and
 * inherited downwards. `employments` is the exception and deliberately first:
 * a contract is inherited by nobody and belongs to one company alone, and the
 * people employed there come before the rules their time is measured by.
 *
 * Shared rather than client-only because three different places have to agree
 * on this list: the panel groups it, the app maps each entry to the permission
 * that gates it, and a sweep over the server routes checks that every section's
 * writes are guarded against landing on a department. A list that lived in the
 * client could not be read by the last of those.
 *
 * Adding an entry here is deliberately noisy — several tests name the set.
 */
export const ORG_UNIT_SETTINGS_SECTIONS = [
  'employments',
  'costCenters',
  'bookingTypes',
  'timeTypes',
  'dayPrograms',
  'workSchedules',
  'publicHolidays',
  'accounts',
  'rules',
] as const;

export type OrgUnitSettingsSectionId =
  (typeof ORG_UNIT_SETTINGS_SECTIONS)[number];
